import { PurchaseItem } from '@/types/purchase.type'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface State {
  purchaseItemList: PurchaseItem[]
  deliveryPurchaseItem: PurchaseItem | null
}

interface Action {
  setPurchaseItemList: (purchaseItemList: PurchaseItem[]) => void
  setDeliveryPurchaseItem: (purchaseItem: PurchaseItem | null) => void
}

export const purchaseItemStore = create<State & Action>()(
  devtools(
    (set) => ({
      purchaseItemList: [],
      deliveryPurchaseItem: null,
      setPurchaseItemList: (purchaseItemList) =>
        set(() => ({ purchaseItemList }), undefined, 'purchaseItem/setPurchaseItemList'),
      setDeliveryPurchaseItem: (purchaseItem) =>
        set(() => ({ deliveryPurchaseItem: purchaseItem }), undefined, 'purchaseItem/setDeliveryPurchaseItem'),
    }),
    { name: 'purchaseItemStore' },
  ),
)
